import { atBqnTarget } from "common/api";

export const parseThroughputUsage = (input) => {
  const [header, ...rows] = input.trim("\n").split("\n");
  const headerAttrs = header.trim("s").split(/\s+/);
  const indexAttrMap = headerAttrs.reduce((acc, value, index) => {
    acc[index] = value;
    return acc;
  }, {});
  return rows.reduce((acc, row) => {
    if (row.trim("s").length > 0) {
      const rowAtrs = row.trim("s").split(/\s+/);
      const item = rowAtrs.reduce((accItem, attr, index) => {
        if (indexAttrMap[index] === "BQN") {
          accItem["bqn"] = attr;
        } else if (indexAttrMap[index] === "INTERFACE") {
          accItem["name"] = attr;
        } else if (indexAttrMap[index] === "BYTES-RX-Mbps") {
          accItem["rx"] = parseFloat(attr);
        } else if (indexAttrMap[index] === "BYTES-TX-Mbps") {
          accItem["tx"] = parseFloat(attr);
        }
        return accItem;
      }, {});
      acc.push(item);
    }
    return acc;
  }, []);
};

export const headerToKey = (name) =>
  name.toLowerCase().replace(/-(\w)/g, (_, first) => first.toUpperCase());

const intoObjectGivenHeader = header => {
  const keys = header.trim().split(/\s+/).map(headerToKey);
  return line =>
    Object.fromEntries(
      line.trim().split(/\s+/).map( (value, index) => [keys[index], value])
    )
}

// Device names never collide between nodes, so wire roles are kept in a
// single map regardless of the BQN node they belong to.
const nameByWireRole = ({accIface, inetIface}) =>
  ({
    [accIface]: accIface + '-access',
    [inetIface]: inetIface + '-inet',
  });

export const parseWireRoles = (response) => {
  const [header, ...rows] = response.trim().split("\n");
  return Object.assign(
    {},
    ...rows.map(intoObjectGivenHeader(header)).map(nameByWireRole)
  );
};


// The data of the BQN selected in the header, or of the whole cluster. Both
// responses keep their BQN column, and the wire roles are kept in a single
// map, so the data needs no BQN to be attributed to it.

export const throughputRetrieval = (mode, bqnId) =>
  ifCl
    .run(atBqnTarget("show interface pkteng bandwidth", mode, bqnId))
    .then(parseThroughputUsage);

export const deviceRolesRetrieval = (mode, bqnId) =>
  ifCl
    .run(atBqnTarget("show pkteng wire", mode, bqnId))
    .then(parseWireRoles)
    .catch(() => ({}));
